import {makeStyles} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import * as React from 'react';

import routeByName from '~/constants/routes';
import useModalById from '~/customHooks/useModalById';
import {MODAL_UNAUTHORIZED} from '~/rootStore/modals/modalsIds';

import Logo from '../Logo';
import ModalBase from '../ModalBase';
import ModalBaseContent from '../ModalBaseContent';

const useStyles = makeStyles(() => ({
  button: {borderRadius: 99, fontSize: 18},
}));

const ModalUnauthorized: React.FC = () => {
  const s = useStyles();
  const {isOpen, close: closeUnauthorizedModal} = useModalById(MODAL_UNAUTHORIZED);
  return (
    <ModalBase showCloseButton open={isOpen} onClose={closeUnauthorizedModal}>
      <div className="px-2 pb-2">
        <ModalBaseContent
          icon={<Logo />}
          title="Oooops!"
          description="In order to perform an action you need to be logged in"
        />
        <Button className={s.button} href={routeByName.signIn}>
          Log in
        </Button>
        <div className="mb-2" />
        <Button className={s.button} href={routeByName.signUp} variant="text">
          Sign Up
        </Button>
      </div>
    </ModalBase>
  );
};

export default ModalUnauthorized;
